import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Http404Component } from './http404/http404.component';
import { AutenticacaoGuard } from './services/autenticacao.guard';
import { FundsComponent } from './logado/extratos/funds/funds.component';
import { ExtTaxaAdmComponent } from "./logado/extratos/ext-taxa-adm/ext-taxa-adm.component";
import { PaymentsComponent } from './logado/financeiro/payments/payments.component';
import { SupportComponent } from './logado/support/support.component';
import { HomeComponent } from './logado/home/home.component';
import { HeaderAdesaoComponent } from './templates/header-adesao/header-adesao.component';
import { HeaderAutoatendimentoComponent } from './templates/header-autoatendimento/header-autoatendimento.component';
import { CadastroComponent } from './logado/cadastro/cadastro.component';
import { NotificationsComponent } from './logado/notifications/notifications.component';
import { DeclaracaoAnualComponent } from "./logado/extratos/declaracao-anual/declaracao-anual.component";
import { MovesComponent } from "./logado/extratos/moves/moves.component";
import { RecebimentosComponent } from "./logado/financeiro/recebimentos/recebimentos.component";
import { SigaSeuPlanoComponent } from "./siga-seu-plano/siga-seu-plano.component";
import { CpfComponent } from "./solicitacao-adesao/cpf/cpf.component";
import { SolicitacaoAdesaoComponent } from "./solicitacao-adesao/solicitacao-adesao/solicitacao-adesao.component";
import { SolicitacaoConcluidaComponent } from "./solicitacao-adesao/solicitacao-concluida/solicitacao-concluida.component";
import { LoginComponent } from "./autenticacao/login/login.component";
import { ConfirmarEmailComponent } from "./autenticacao/confirmar-email/confirmar-email.component";
import { ReenviarTokenEmailComponent } from "./autenticacao/reenviar-token-email/reenviar-token-email.component";
import { EsqueciMinhaSenhaEnviarEmailComponent } from "./autenticacao/esqueci-minha-senha-enviar-email/esqueci-minha-senha-enviar-email.component";
import { EsqueciMinhaSenhaAlterarComponent } from "./autenticacao/esqueci-minha-senha-alterar/esqueci-minha-senha-alterar.component";
import { SimuladorSeguroComponent } from "./simulador-seguro/simulador-seguro.component";
import { SimularComponent } from "./simulador-seguro/simular/simular.component";
import { FimAdesaoSeguroComponent } from "./logado/seguro-adesao/fim-adesao/fim-adesao-seguro.component";
import { SeguroAdesaoComponent } from "./logado/seguro-adesao/seguro-adesao.component";
import { AcompanharSolicitacaoComponent } from "./logado/seguro/acompanhar-solicitacao/acompanhar-solicitacao.component";
import { MeusSegurosComponent } from "./logado/seguro/meus-seguros/meus-seguros.component";
import { SeguroComponent } from "./logado/seguro/seguro.component";
import { AdesaoComponent } from "./logado/adesao/adesao/adesao.component";
import { FimAdesaoComponent } from "./logado/adesao/fim-adesao/fim-adesao.component";

export const routes: Routes = [

  {
    path: "",
    redirectTo: "/autenticacao/login",
    pathMatch: "full",
    title: 'Autoatendimento'
  },

  {
    path: "autenticacao",
    component: HeaderAdesaoComponent,
    children: [
      { path: "login", component: LoginComponent },
      { path: "confirmar-email/:hash", component: ConfirmarEmailComponent },
      { path: "reenviar-token-email", component: ReenviarTokenEmailComponent },
      { path: "esqueci-minha-senha-enviar-email", component: EsqueciMinhaSenhaEnviarEmailComponent },
      { path: "esqueci-minha-senha-alterar/:token", component: EsqueciMinhaSenhaAlterarComponent }
    ],
    title: 'Autenticação'
  },
    //REMOVIDO PRE ADESAO PARA TESTES.
    /*
  {
    path: "pre-adesao",
    component: HeaderAdesaoComponent,
    children: [
      { path: "cpf", component: CpfComponent },
      { path: "cadastro", component: SolicitacaoAdesaoComponent },
      { path: "conclusao", component:  SolicitacaoConcluidaComponent}
    ],
    title: 'Solicitação de Adesão'
  },*/

  {
    path: 'simulador-seguro',
    children: [
        { path: '', component: SimuladorSeguroComponent },
        { path: 'simular', component: SimularComponent }
    ],
    title: 'Simulador de Seguro'
  },

  {
    path: 'siga-seu-plano',
    component: SigaSeuPlanoComponent,
    title: 'Siga Seu Plano'
  },

  //Autoatendimetno
  {
    path: "logado",
    title: 'Autoatendimento',
    component: HeaderAutoatendimentoComponent,
    canActivateChild: [AutenticacaoGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        title: 'Home'
      },

      {
        path: 'extratos/fundos',
        component: FundsComponent ,
        title: 'Extrato de Fundos'
      },

      {
        path: 'extratos/movimentacoes',
        component: MovesComponent,
        title: 'Extrato de Movimentações'
      },

      {
        path: 'extratos/taxa-adm',
        component: ExtTaxaAdmComponent,
        title: 'Extrato de Taxa de Administração'
      },

      {
        path: 'extratos/declaracao-anual',
        component: DeclaracaoAnualComponent,
        title: 'Declaração Anual'
      },

      {
        path: 'financeiro/recebimentos',
        component: RecebimentosComponent,
        title: 'Recebimentos'
      },

      {
        path: 'financeiro/formas-pagamentos',
        component: PaymentsComponent,
        title: 'Formas de Pagamentos'
      },

      {
        path: 'atendimento',
        component: SupportComponent,
        title: 'Atendimento'
      },

      {
        path: 'cadastro',
        component: CadastroComponent,
        title: 'Cadastro'
      },

      {
        path: 'notificacoes',
        component: NotificationsComponent,
        title: 'Notificações'
      },

      {
        path: 'notificacoes/:codAviTipo',
        component: NotificationsComponent,
        title: 'Notificações'
      },

      {
        path: 'seguro',
        children: [
            { path: '', component: SeguroComponent },
            { path: 'seguros-contratados', component: MeusSegurosComponent },
            { path: 'acompanhar-solicitacoes', component: AcompanharSolicitacaoComponent }
        ],
        title: 'Seguro'
      },

      {
        path: 'seguro-adesao',
        children: [
            { path: '', component: SeguroAdesaoComponent },
            { path: 'fim-adesao', component: FimAdesaoSeguroComponent }
        ],
        title: 'Seguro Adesão'
      }
    ]
  },

  //Pós Adesão
  {
    path: "logado",
    title: 'Pós Adesão',
    component: HeaderAdesaoComponent,
    canActivateChild: [AutenticacaoGuard],
    children: [

      {
        path: "adesao",
        runGuardsAndResolvers: 'always',
        children: [
          { path: "", component: AdesaoComponent },
          { path: "fim-adesao", component: FimAdesaoComponent }
        ],
        title: 'Adesão'
      }

    ]
  },

  {
    path: "404",
    component: Http404Component,
    title: 'Página Não Encontrada'
  },

  {
    path: "**",
    redirectTo: "404",
    title: 'Página Não Encontrada'
  },

];

export class AppRoutingModule {}
